import { Auth0Client } from "@auth0/auth0-spa-js";
import router from "../../router";
import rs_wechat from "@/config/rs_wechat";
import { getCurrentEnv, SUPPORT_ENV } from "@/utils/util";

import { buildAuth0Options, CreatorAuth } from "./client";

const env = getCurrentEnv();
const config = env === SUPPORT_ENV.prod
  ? rs_wechat.prod
  : env === SUPPORT_ENV.qa ? rs_wechat.qa : rs_wechat.dev;

export const auth = new CreatorAuth(
  new Auth0Client(buildAuth0Options(config.auth0)),
  async (target) => { await router.replace(target); }
);
